import {
    GET_ACTIVITY_LOG_REQUEST,
    GET_ACTIVITY_LOG_SUCCESS,
    GET_ACTIVITY_LOG_FAIL,
    GET_ACTIVITY_LOGS_QUOTATION_REQUEST,
    GET_ACTIVITY_LOGS_QUOTATION_SUCCESS,
    GET_ACTIVITY_LOGS_QUOTATION_FAIL,
} from "../constant";

const initialState = {
    activityLogs: [],
    activityLogsForQuotation: [],
    isLoading: false,
    error: null,
};

const activityLogsReducer = (state = initialState, action) => {
    switch (action.type) {
        // Fetch activity logs
        case GET_ACTIVITY_LOG_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case GET_ACTIVITY_LOG_SUCCESS:
            return {
                ...state,
                activityLogs: action.payload.data,
                totalRecords: action.payload?.total_count,
                isLoading: false,
                error: null,
            };
        case GET_ACTIVITY_LOG_FAIL:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
       

        default:
            return state;
    }
};

export { activityLogsReducer };
